import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { AppContext } from 'store/AppContext';
import { getKjorstadir } from 'common/services/apiService';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function KjorstadirFilter(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { setFilters, kjordaemisnumer, sveitarfelagsnumer, setKjorstadirFromFilter, disabled } = props;
  const [kjorstadirList, setKjorstadirList] = useState([]);
  const [kjorstadurId, setKjorstadurId] = useState('');

  useEffect(() => {
    async function fetchKjorstadir() {
      const { data, isSuccess, error } = await getKjorstadir(context, []);
      
      if (isSuccess) {
        setKjorstadirList(data);
        setKjorstadirFromFilter && setKjorstadirFromFilter(data);
      } else {
        console.error(error);
      }
    };

    fetchKjorstadir();
  }, [context, setKjorstadirFromFilter]);

  // Reset when kjördæmi changes
  useEffect(() => {
    setKjorstadurId('');
    setFilters(state => ({
      ...state,
      kjorstadarnumer: '',
      sveitarfelagsnumer: ''
    }));
  }, [kjordaemisnumer, setFilters]);

  // Reset when sveitarfelag changes
  useEffect(() => {
    setKjorstadurId('');
    setFilters(state => ({
      ...state,
      kjorstadarnumer: ''
    }));
  }, [sveitarfelagsnumer, setFilters]);

  // Need to set filters for both kjorstadur and sveitarfelag
  // Otherwise there's no context of where the kjorstadur is
  const handleChange = event => {
    setKjorstadurId(event.target.value);
    
    if (event.target.value === '') {
      setFilters(state => ({
        ...state,
        kjorstadarnumer: '',
        sveitarfelagsnumer: sveitarfelagsnumer
      }));
    } else {
      const kjorstadur = kjorstadirList.find(k => k.kjorstadurId === event.target.value);
      setFilters(state => ({
        ...state,
        kjorstadarnumer: kjorstadur.kjorstadurNumer,
        sveitarfelagsnumer: kjorstadur.sveitarfelagsnumer
      }));
    }
  };

  const filterKjorstadir = (kjorstadur) => {
    if (sveitarfelagsnumer !== undefined && sveitarfelagsnumer !== '') {
      return kjorstadur.numerKjordaemis === kjordaemisnumer && kjorstadur.sveitarfelagsnumer === sveitarfelagsnumer;
    }

    return kjorstadur.numerKjordaemis === kjordaemisnumer;
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="filters-kjorstadir-select" shrink>
          Kjörstaður
        </InputLabel>
        <Select
          labelId="filters-kjorstadir-select-label"
          id="filters-kjorstadir-select"
          value={kjorstadurId ? kjorstadurId : ''}
          displayEmpty={true}
          onChange={handleChange}
          disabled={disabled ? disabled : false}
        >
          <MenuItem value="">
            <em>Allir kjörstaðir</em>
          </MenuItem>
          {kjorstadirList
            .filter(filterKjorstadir)
            .map((k) => (
              <MenuItem key={k.kjorstadurId} value={k.kjorstadurId}>
                <Typography>
                  {`${k.kjorstadur} (${k.numerKjordaemis}.${k.kjorstadurNumer})`}
                  <br />
                  <span style={{ fontSize: '0.75rem' }}>{k.sveitarfelag}</span>
                </Typography>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
}